import { BaseIcon } from './base-icon.js';
import { svg } from 'lit';

/**
 * Success Icon Component
 * Circle with checkmark (outline style)
 * Used for success messages and confirmations
 */
class SuccessIcon extends BaseIcon {
    getSvgAttributes() {
        return {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': '2',
        };
    }

    renderIconPath() {
        return svg`
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
        `;
    }
}

customElements.define('success-icon', SuccessIcon);
